module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vc-alpha",
    attrs: {
      "role": "HuePanel"
    }
  }, [_c('div', {
    staticClass: "vc-alpha-checkboard-wrap"
  }, [_c('checkboard')], 1), _vm._v(" "), _c('div', {
    staticClass: "vc-alpha-gradient",
    style: ({
      background: _vm.gradientColor
    })
  }), _vm._v(" "), _c('div', {
    ref: "container",
    staticClass: "vc-alpha-container",
    on: {
      "mousedown": _vm.handleMouseDown,
      "touchmove": _vm.handleChange,
      "touchstart": _vm.handleChange
    }
  }, [_c('div', {
    staticClass: "vc-alpha-pointer",
    style: ({
      left: _vm.colors.a * 100 + '%'
    }),
    attrs: {
      "role": "CurrentAlphaPointer"
    }
  }, [_c('div', {
    staticClass: "vc-alpha-picker"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-560d4242"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-color/src/components/common/Alpha.vue
// module id = 1388
// module chunks = 0